import React, { useState, useRef } from 'react'
import useOnClickOutside from './hooks/useOnClickOutside'
import { PrismicLink } from '@prismicio/react'

const Dropdown = (props) => {
  const ref = useRef()
  const [isOpen, setOpen] = useState(false)
  const dropdownToggle = () => setOpen(!isOpen)

  useOnClickOutside(ref, () => setOpen(false))

  return (
    <li ref={ref} className='relative'>
      <button aria-expanded={isOpen} aria-haspopup='true' className={props.navStyles} onClick={dropdownToggle} onKeyDown={dropdownToggle}>
        {props.children}
        <svg xmlns='http://www.w3.org/2000/svg' className='w-5' height='1em'>
          <path d='M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' fill='currentColor' />
          <path d='M0 0h24v24H0z' fill='none' />
        </svg>
      </button>
      <ul className={`${!isOpen ? 'hidden' : 'min-w-max flex flex-col bg-sky-50 md:absolute md:left-0 md:mt-2 md:rounded md:p-3 md:shadow-md lg:bg-white'}`}>
        {props.items.map((subNav, index) => {
          return (
            <li key={`subNav-${index}`}>
              <PrismicLink className={props.subNavStyles} field={subNav.subnav_link}>
                {subNav.subnav_link_label}
              </PrismicLink>
            </li>
          )
        })}
      </ul>
    </li>
  )
}

export default Dropdown
